module.exports = __webpack_public_path__ + "static/media/ml.64aa8367.svg";